import { CookiePolicyArchivesPage } from '@/components/pages/cookie-policy/CookiePolicyArchivesPage'
import { getArchivedCookiePolicy, getCookiePolicyArchivePage } from '@/graphql/CookiePolicy'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const page = await getCookiePolicyArchivePage(preview)
  const archivedCookiePolicies = await getArchivedCookiePolicy()

  if (page?.cookiePolicyArchivesPage) {
    return {
      props: {
        page: page.cookiePolicyArchivesPage,
        archivedCookiePolicies: archivedCookiePolicies?.allCookiePolicyPages || [],
      },
    }
  }

  throw new Error('No Cookie Policy Archive page found')
}

export default CookiePolicyArchivesPage
